module.exports = __webpack_public_path__ + "media/images/cropplan-5a253030bc28fe1ee1c515b8fdf7b55e.png";